import { useState } from "react";
import { Slider } from "@/components/ui/slider";
import { FONT } from "@/lib/photoEdit";
import { ColorRow } from "./ColorRow";

export const TextInput = ({ initial, boxW, onDone }) => {
  const [text, setText] = useState(initial.text);
  const [color, setColor] = useState(initial.color);
  const [size, setSize] = useState(initial.size);
  return (
    <div data-testid="photo-text-overlay" className="absolute inset-0 z-30 bg-black/75 flex flex-col pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <div className="flex justify-end p-4">
        <button type="button" data-testid="photo-text-done-btn" onClick={() => onDone({ ...initial, text: text.trim() ? text : "", color, size })}
          className="rounded-full bg-[#2563EB] px-5 py-2 text-sm font-semibold text-white active:scale-95 transition-transform">
          Done
        </button>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <textarea
          autoFocus
          data-testid="photo-text-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Type something…"
          rows={3}
          style={{ color, fontSize: Math.max(20, Math.min(56, size * (boxW || window.innerWidth))), fontFamily: FONT }}
          className="w-full resize-none bg-transparent text-center font-bold leading-[1.2] outline-none placeholder:text-white/40 [text-shadow:0_1px_4px_rgba(0,0,0,0.6)]"
        />
      </div>
      <div className="space-y-5 px-8 pb-8">
        <Slider data-testid="photo-text-size" min={0.04} max={0.16} step={0.005} value={[size]} onValueChange={([v]) => setSize(v)} />
        <ColorRow value={color} onChange={setColor} testid="photo-text-color" />
      </div>
    </div>
  );
};
